import BaseModule from '@/store/baseModule';
import BaseModulePlugins from '@/store/baseModule/plugins';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';
import { ACTIONPLANS_ACTIONS_USER_EXCHANGES_TYPES_MODULE_NAME } from '@/store/modules/actionplans/constants';

export default (store) => {
  const MODULE_NAME = ACTIONPLANS_ACTIONS_USER_EXCHANGES_TYPES_MODULE_NAME;
  const MODULE_PATH = MODULE_NAME.join('/');

  store.registerModule(
    MODULE_NAME,
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.MYPREDITY_BASE_URI}/actions/user_exchanges/ref_use_type`,
        }),
        retry: { nbLeft: 3, timeout: 2000 },
      }),
    })
  );
  const basePlugin = new BaseModulePlugins({
    module: MODULE_PATH,
    store,
  });
  basePlugin.onInit(() => store.dispatch(`${MODULE_PATH}/initItems`));
};
